export default [
    {
        path: "planilla/historicos-renta",
        name: "planilla-historicos-renta",
        component: () => import("../views/HistoricosRenta.vue"),
    },
];
